import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { InterpolateDateFieldPipe } from './pipes/final-countdown.pipes';
import { PieceFinalCountdownRenderComponent } from './render/piece-final-countdown-render.component';
import { ProgressBarComponent } from './render/progress-bar-render/progress-bar.component';


export const pieceFinalCountdownRenderModuleEntryComponents = [
  PieceFinalCountdownRenderComponent,
  ProgressBarComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: [
    ...pieceFinalCountdownRenderModuleEntryComponents,
    InterpolateDateFieldPipe
  ]
})
export class PieceFinalCountdownRenderModule {}

export default pieceFinalCountdownRenderModuleEntryComponents;
